// extracted by mini-css-extract-plugin
module.exports = {"achievements":"Achievement_achievements__1dUiS","imgCName":"Achievement_imgCName__1UZ4L"};